<app-indicator-filter></app-indicator-filter>
<p-divider></p-divider>
<div *ngIf="indicatorStore.count() as indicators">
  <p-pickList
    #listPickerCtrl
    *ngIf="categoryStore.count() as categories"
    [source]="treeSorted"
    [target]="selected"
    sourceHeader="Indikatoren"
    targetHeader="Auswahl"
    [dragdrop]="true"
    [responsive]="true"
    [showSourceControls]="showSourceControls"
    [showTargetControls]="showTargetControls"
    (onMoveToSource)="updateSelection()"
    (onMoveToTarget)="updateSelection()"
    (onMoveAllToTarget)="updateSelection()"
    (onMoveAllToSource)="updateSelection()"
    (onTargetReorder)="updateSelection()"
    (onSourceSelect)="checkForSelectionHooks($event)"
    [sourceStyle]="{ height: '25rem' }"
    [targetStyle]="{ height: '25rem' }"
    breakpoint="1400px">
    <ng-template pTemplate="targetHeader">
      Auswahl
      @if (targetHeaderSubtitle) {
        <br />
        <span class="font-light text-xs text-color-secondary">{{
          targetHeaderSubtitle
        }}</span>
      }
    </ng-template>
    <ng-template let-indicator pTemplate="item">
      <div
        class="flex-1 flex flex-column gap-2"
        [ngClass]="{ 'pl-3': indicator.parent }">
        <div class="flex align-items-center gap-2 text-lg">
          <i
            class="fas"
            [ngClass]="{
              'fa-ruler-combined': indicator.isSet,
              'fa-ruler-vertical': !indicator.isSet,
              'fa-file-import': indicator.parent,
            }"></i>
          <span>
            {{ indicator.name }}
          </span>
          <p-badge
            severity="secondary"
            class="ml-auto"
            *ngIf="units[indicator.unit]"
            [value]="
              units[indicator.unit].symbol || units[indicator.unit].name
            "></p-badge>
        </div>

        <div class="flex align-items-center gap-2">
          <p-tag
            [pTooltip]="indicatorStore.getById(indicator.parent).name"
            [rounded]="true"
            *ngIf="indicator.parent"
            icon="fas fa-ruler-combined"
            styleClass="p-tag-parent"
            [value]="indicatorStore.getById(indicator.parent).name | trim: 15">
          </p-tag>
          <p-tag
            [pTooltip]="categoryStore.getPathById(indicator.category)"
            [rounded]="true"
            icon="fas fa-folder"
            styleClass="p-tag-category"
            [value]="categoryStore.getPathById(indicator.category) | trim: 15">
          </p-tag>
        </div>
        <app-tag-list
          styleClass="text-xs"
          *ngIf="indicator.tags?.length"
          [tagIds]="indicator.tags"></app-tag-list>
      </div>
    </ng-template>
  </p-pickList>
</div>
